import styled from '@emotion/styled';
export const MarkerDetailLink = styled('div')(() => ({
  position: 'absolute',
  right: '20px',
  top: '20px',
}));
